<template>
   <div class="sidebar"> 
     <nav class="navbar navbar-expand-lg navbar-inverse bg-dark h-120">
  <router-link to="/"><a class="navbar-brand p-2">{{title}}</a></router-link>
  <button class="navbar-toggler m-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="#"><router-link :to="{path : appartement}"> Home </router-link> <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :href="link">Réserver</a>
      </li>
      <li class="nav-item">
        <router-link to="/contact"><a class="nav-link">Contact</a></router-link>
        
      </li>
      
      
    </ul>
    <form class="form-inline my-2 ml-lg-auto d-flex p-2 justify-content-center my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form>
  </div>
</nav></div>
</template>

<script>
export default {
    name : 'Sidebar',
    props :{
      title: {
        default : "Logis des Clos",
        type : String
      },
      link : {
        default : "https://www.airbnb.fr/rooms/34057293",
        type : String
      },
      appartement : {
        default : '/logisdesclos',
        type : String,
      }

    }, 
    mounted(){
      console.log(this.$props.link)
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
.h-120 {
    height: 120px!important;
}
a {
    color: aliceblue!important;
    font-family: 'Indie Flower', cursive;
    font-size: 20px;
}
.sidebar {
  z-index: 2;
  position: relative;
}

.nav-link:hover {
  text-decoration: underline!important;
}

a:hover {
    color: aliceblue!important;
}

.navbar-toggler-icon {
  background-image: url('../assets/imgs/list.png');
}

.navbar {
  padding: 0rem!important;
}

.navbar-toggler {
  border: 1px solid white!important;
}

.navbar-collapse {
  background-color: #343a40!important;
}
</style>